var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_stars'] = require('../../stars.html.mustache');

ProductReviews.Views.ReviewRating = Backbone.View.extend({
  render: function() {
    return this.$el.append(ProductReviews.Templates['product_reviews_stars'].render(this.model.attributes));
  }
});

module.exports = ProductReviews.Views.ReviewRating;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvdmlld3MvcHJvZHVjdF9yZXZpZXdzX3Jldmlld19yYXRpbmcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvdmlld3MvcHJvZHVjdF9yZXZpZXdzX3Jldmlld19yYXRpbmcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxtQ0FBaUIsTUFBTSxDQUFDLGlCQUFQLE1BQU0sQ0FBQyxpQkFBa0I7OztFQUMxQyxjQUFjLENBQUMsUUFBUzs7OztFQUN4QixjQUFjLENBQUMsWUFBYTs7O0FBRTVCLGNBQWMsQ0FBQyxTQUFVLENBQUEsdUJBQUEsQ0FBekIsR0FBb0QsT0FBQSxDQUFRLDJCQUFSOztBQUVwRCxjQUFjLENBQUMsS0FBSyxDQUFDLFlBQXJCLEdBQW9DLFFBQVEsQ0FBQyxJQUFJLENBQUMsTUFBZCxDQUNsQztFQUFBLE1BQUEsRUFBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksY0FBYyxDQUFDLFNBQVUsQ0FBQSx1QkFBQSxDQUF3QixDQUFDLE1BQWxELENBQXlELElBQUMsQ0FBQSxLQUFLLENBQUMsVUFBaEUsQ0FBWjtFQURNLENBQVI7Q0FEa0M7O0FBS3BDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGNBQWMsQ0FBQyxLQUFLLENBQUMifQ==
